import { useThemeUI as l, Flex as m } from "theme-ui";
import { jsx as x } from "theme-ui/jsx-runtime";
const c = (e) => {
  const {
    inputSize: t,
    disabled: n,
    sx: r,
    children: i,
    ...o
  } = e, {
    theme: s
  } = l();
  return /* @__PURE__ */ x(m, {
    ...o,
    sx: {
      transition: "all",
      flexShrink: 0,
      height: 9,
      alignItems: "center",
      ...s.inputAdornmentSizes[t],
      ...n && {
        color: "disabledText"
      },
      ...r
    },
    children: i
  });
};
export {
  c as InputAdornment
};
